// extracted by mini-css-extract-plugin
module.exports = {"chart":"index-module--chart--1406Y"};